import sette from "./core/sette.js";
import Components from "./modules/components.js";
import MediaQueries from "./modules/media-queries.js";
// import PageLoader from "./modules/page-loader.js";

sette.init({
  modules: {
    components: {
      module: Components,
      params: {}
    },
    mediaQueries: {
      module: MediaQueries,
      params: {
        mediaQueries: [
          {
            name: "small",
            mediaQuery: "screen and (max-width: 768px)"
          },
          {
            name: "medium",
            mediaQuery: "screen and (min-width: 769px) and (max-width: 1024px)"
          },
          {
            name: "large",
            mediaQuery: "screen and (min-width: 1025px) and (max-width: 1440px)"
          },
          {
            name: "wide",
            mediaQuery: "screen and (min-width: 1441px)"
          }
        ]
      }
    },
    // pageLoader: {
    //   module: PageLoader,
    //   params: {
    //     active: true
    //   }
    // }
  }
});

sette.emitter = new Vue();

window.sette = sette;

const ua = window.navigator.userAgent;
if (ua.indexOf('MSIE ') || ua.indexOf('Trident/')) {
  document.body.classList.add('is-ie')
}